exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".messageSection {\n  min-height: unset; }\n  .messageSection .message {\n    display: flex;\n    align-items: center;\n    padding: 15px 20px;\n    background-color: #FFFFFF;\n    border: 1px solid #F2F2F2;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15); }\n    .messageSection .message .message-date {\n      margin-right: 22px; }\n    .messageSection .message .message-new {\n      padding: 1px 8px;\n      margin-right: 5px;\n      border-radius: 7px;\n      background-color: #DC8A5E;\n      color: #FFFFFF;\n      font-size: 10px;\n      font-weight: bold;\n      line-height: 13px;\n      letter-spacing: 0.5px; }\n    .messageSection .message .message-text {\n      display: inline;\n      flex-grow: 1; }\n\n.message-page-controls {\n  border: none;\n  box-shadow: none;\n  background-color: inherit; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/dashboard/messages/messages.scss
// module id = 1287
// module chunks = 0